/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Templates_Link_TargetInputs */

const en_tables_templates_link_target = /** @type {(inputs: Tables_Templates_Link_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Target`)
};

const de_tables_templates_link_target = /** @type {(inputs: Tables_Templates_Link_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Litndeaktiviert Ziel`)
};

/**
* | output |
* | --- |
* | "Link Target" |
*
* @param {Tables_Templates_Link_TargetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_templates_link_target = /** @type {((inputs?: Tables_Templates_Link_TargetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Templates_Link_TargetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_templates_link_target(inputs)
	return de_tables_templates_link_target(inputs)
});